import * as moment from 'moment-timezone';
import 'regenerator-runtime/runtime'
import React from 'react';
import Compressor from 'compressorjs';
import { stringify } from 'qs';

const autocompleteFieldStyles = {
  street_number: 'short_name',
  route: 'long_name',
  locality: 'long_name',
  administrative_area_level_1: 'short_name',
  administrative_area_level_2: 'short_name',
  country: 'long_name',
  postal_code: 'short_name'
};
const autocompleteMapping = {
  street_number: 'address_1',
  route: 'address_1',
  locality: 'city',
  administrative_area_level_1: 'state',
  country: 'country',
  administrative_area_level_2: 'county',
  postal_code: 'zip'
};

export const formatGoogleAddressData = (addressComponents) => {
  let addressObject = {};
  for (var i = 0; i < addressComponents.length; i++) {
    let addressComponent = addressComponents[i];
    var addressType = addressComponent.types[0];
    let value = addressComponent[autocompleteFieldStyles[addressType]];

    let mapping = autocompleteMapping[addressType];

    if(mapping != undefined) {
      if(addressObject[mapping] == undefined) {
        addressObject[mapping] = value;
      } else {
        addressObject[mapping] += ' ' + value;
      }
    }

  }
  return addressObject;
}

export const currentChatIdOpen = () => {
  return isLocalStorageSupported() ? localStorage.getItem(`current-cs-chat-open`) : false;
}

export const setCurrentChatIdOpen = (value) => {
  return isLocalStorageSupported() && localStorage.setItem(`current-cs-chat-open`, value);
}

export const isSurveyTakenFromLocalStorage = (surveyId) => {
  return isLocalStorageSupported() && localStorage.getItem(`survey-taken-${surveyId}`);
}

export const isMyChatOpen = () => {
  return isLocalStorageSupported() ? localStorage.getItem(`my-cs-chat-open`) : false;
}

export const setMyChatOpen = (value) => {
  return isLocalStorageSupported() && localStorage.setItem(`my-cs-chat-open`, value);
}

export const isLocalStorageSupported = () => {
  var mod = 'localstoragetest';
  try {
      localStorage.setItem(mod, mod);
      localStorage.removeItem(mod);
      return true;
  } catch(e) {
      return false;
  }
}

export const setLastReadAtForAccountNotifications = () => {
  return isLocalStorageSupported() && localStorage.setItem(`last-read-at-account-notifications`, Date.now());
}

export const lastReadAtForAccountNotifications = () => {
  return isLocalStorageSupported() && localStorage.getItem(`last-read-at-account-notifications`);
}

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const formatValuesForMeeting = (values) => {
  let startsAt = moment(values.startDate);
  let endsAt = moment(values.startDate);
  startsAt.set({
    hour: values.startTime.get('hour'),
    minute: values.startTime.get('minute'),
    second: 0,
    millisecond: 0,
  });
  endsAt.set({
    hour: values.endTime.get('hour'),
    minute: values.endTime.get('minute'),
    second: 0,
    millisecond: 0,
  });
  let data = {
    meeting: {
      taggings_attributes: [],
      name: values.title,
      description: values.details,
      location_attributes: {
        name: values.location
      },
      participant_ids: values.participants.map((participant) => participant.id),
      event_id: values.eventId,
      account_id: values.accountId,
      starts_at: startsAt.format(),
      ends_at: endsAt.format(),
      video_enabled: values.videoEnabled
    }
  }
  data.meeting.taggings_attributes.push(...getTaggingAttributes("providing_tags", values.providingTagIds));
  data.meeting.taggings_attributes.push(...getTaggingAttributes("seeking_tags", values.seekingTagIds));
  return JSON.stringify(data);
}

export const formatValuesForOpportunity = (values) => {
  let startsAt = moment(values.startDate);
  let endsAt = moment(values.endDate);
  startsAt.set({
    hour: values.startTime.get('hour'),
    minute: values.startTime.get('minute'),
    second: 0,
    millisecond: 0,
  });
  endsAt.set({
    hour: values.endTime.get('hour'),
    minute: values.endTime.get('minute'),
    second: 0,
    millisecond: 0,
  });
  const data = new FormData();
  data.append('opportunity[name]', values.title);
  data.append('opportunity[description]', values.details);
  data.append('opportunity[event_id]', values.eventId);
  data.append('opportunity[account_id]', values.accountId);
  data.append('opportunity[starts_at]', startsAt.format());
  data.append('opportunity[ends_at]', endsAt.format());
  data.append('opportunity[options][show_chat]', values.showChat ? "1" : "0");
  data.append('opportunity[options][show_email]', values.showContactInfo ? "1" : "0");
  data.append('opportunity[options][allow_fulfillment_requests]', values.allowFulfillmentRequests ? "1" : "0");
  let i = 0;
  if(values.toUploadFiles && values.toUploadFiles.length > 0) {
    try {
      values.toUploadFiles.forEach((file) => {
        data.append('opportunity[attachments_attributes][' + i + '][file]', file.data);
        data.append('opportunity[attachments_attributes][' + i + '][name]', file.name);
        i++;
      });
    } catch(e) {
      console.error(e);
    }
  }
  if(values.toDeleteFiles && values.toDeleteFiles.length > 0) {
    try {
      values.toDeleteFiles.forEach((file) => {
        data.append('opportunity[attachments_attributes][' + i + '][_destroy]', "1");
        data.append('opportunity[attachments_attributes][' + i + '][id]', file.id);
        i++;
      });
    } catch(e) {
      console.error(e);
    }
  }
  //data.opportunity.taggings_attributes.push(...getTaggingAttributes("providing_tags", values.providingTagIds));
  //data.opportunity.taggings_attributes.push(...getTaggingAttributes("seeking_tags", values.seekingTagIds));
  return data;
}

export const bodyForCloseOpportunity = (values, close) => {
  let closed_value = close ? "1" : "0";
  let data = {
    opportunity: {
      close_opportunity: closed_value,
      closed_message: values.closedMessage
    }
  }
  return JSON.stringify(data);
}

export const formatValuesForNote = (values, notableType, notableId) => {
  const data = new FormData();
  const selectedNotableType = (values.notableCategory ?? notableType) || notableType;
  const selectedNotableId = (values.notableItem ?? notableId) || notableId;

  data.append('note[body]', values.body);
  data.append('note[notable_type]', selectedNotableType);
  data.append('note[notable_id]', selectedNotableId);
  data.append('note[contextable_type]', values.contextCategory);
  data.append('note[contextable_id]', values.contextItem);

  let i = 0;
  if (values.toUploadFiles && values.toUploadFiles.length > 0) {
    try {
      values.toUploadFiles.forEach((file) => {
        data.append('note[attachments_attributes][' + i + '][file]', file.data);
        i++;
      });
    } catch (e) {
      console.error(e);
    }
  }

  if (values.toDeleteFiles && values.toDeleteFiles.length > 0) {
    try {
      values.toDeleteFiles.forEach((file) => {
        data.append('note[attachments_attributes][' + i + '][_destroy]', "1");
        data.append('note[attachments_attributes][' + i + '][id]', file.id);
        i++;
      });
    } catch (e) {
      console.error(e);
    }
  }

  return data;
};

export const formatValuesForStorefront = (values) => {
  const data = new FormData();
  data.append('storefront[name]', values.title);
  data.append('storefront[description]', values.details);
  data.append('storefront[event_id]', values.eventId);
  data.append('storefront[account_id]', values.accountId);
  //data.append('storefront[options][show_email]', values.showContactInfo ? "1" : "0");
  let i = 0;
  if(values.toUploadFiles && values.toUploadFiles.length > 0) {
    try {
      values.toUploadFiles.forEach((file) => {
        data.append('storefront[attachments_attributes][' + i + '][file]', file.data);
        data.append('storefront[attachments_attributes][' + i + '][name]', file.name);
        i++;
      });
    } catch(e) {
      console.error(e);
    }
  }
  if(values.toDeleteFiles && values.toDeleteFiles.length > 0) {
    try {
      values.toDeleteFiles.forEach((file) => {
        data.append('storefront[attachments_attributes][' + i + '][_destroy]', "1");
        data.append('storefront[attachments_attributes][' + i + '][id]', file.id);
        i++;
      });
    } catch(e) {
      console.error(e);
    }
  }
  //data.opportunity.taggings_attributes.push(...getTaggingAttributes("providing_tags", values.providingTagIds));
  //data.opportunity.taggings_attributes.push(...getTaggingAttributes("seeking_tags", values.seekingTagIds));
  return data;
}

export const formatValuesForPost = async (values) => {
  let data = {
    post: {
      attachments_attributes: [],
      text: values.text,
      providing_tag_ids: values.selectedProvidingTagIds,
      seeking_tag_ids: values.selectedSeekingTagIds
    }
  }
  if(values.file) {
    try {
      let newFile = await compressFile(values.file.data, 0.8);
      data["post"]["image_data"] = await readAndChangeToBase64Url(newFile);
    } catch(e) {
      console.error(e);
    }
  }
  return data;
}

export const formatValuesForFulfillmentRequest = (values) => {
  const data = new FormData();
  data.append('fulfillment_request[message]', values.message);
  data.append('fulfillment_request[account_id]', values.accountId);
  data.append('fulfillment_request[opportunity_id]', values.opportunityId);
  if(values.files) {
    try {
      values.files.forEach((file) => {
        data.append('fulfillment_request[attachments_attributes][][file]', file.data);
        data.append('fulfillment_request[attachments_attributes][][name]', file.name);
      });
    } catch(e) {
      console.error(e);
    }
  }
  //data.fulfillment_request.taggings_attributes.push(...getTaggingAttributes("providing_tags", values.providingTagIds));
  //data.fulfillment_request.taggings_attributes.push(...getTaggingAttributes("seeking_tags", values.seekingTagIds));
  return data;
}

export const formatValuesForConnection = (values) => {
  let data = {
    match: {
      taggings_attributes: [],
      message: values.connectionMessage,
      other_id: values.other_id,
      event_id: values.event_id
    }
  }
  data.match.taggings_attributes.push(...getTaggingAttributes("providing_tags", values.providingTagIds));
  data.match.taggings_attributes.push(...getTaggingAttributes("seeking_tags", values.seekingTagIds));
  return JSON.stringify(data);
}

export const getTaggingAttributes = (context, ids) => {
  let arr = [];
  for (let index = 0; index < ids.length; index++) {
    const id = ids[index];
    arr.push({
      "context": context,
      "tag_id": id,
      "workflow_state": "active"
    })
  }
  return arr;
}
export const simpleRange = (from, to, step = 1) => {
  let i = from;
  const range = [];

  while (i <= to) {
    range.push(i);
    i += step;
  }

  return range;
}

export const getModalTags = (type) => {
  if(type == "seeking") {
    return "popularSeekingTags";
  } else if(type == "providing") {
    return "popularProvidingTags";
  } else {
    return "tags";
  }
}
export const getModalTagsSelected = (type) => {
  if(type == "seeking") {
    return "selectedSeekingTagIds";
  } else if(type == "providing") {
    return "selectedProvidingTagIds";
  }
}
export const getMyTags = (type) => {
  if(type == "seeking") {
    return "selectedSeekingTags";
  } else if(type == "providing") {
    return "selectedProvidingTags";
  }
}
export const isMobile = () => {
  if (typeof navigator === 'undefined' || typeof navigator.userAgent !== 'string') {
    return false;
  }
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

export const attendeeChatEnabled = () => {
  return ["true", true].includes(connectspace_config.event_attendee_chat_enabled);
}

export const getInputErrorMessage = (error, touched, slim = false) => {
  const className = slim ? "cs-pink fs-xs mthalf mlhalf" : "cs-pink fs-sm";
  if(error && touched) {
    return (<div className={className}>{error}</div>)
  } else {
    return null;
  }
}

export const readAndChangeToBase64Url = (blob) => {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      resolve(e.target.result.split("base64,")[1]);
    }
    reader.readAsDataURL(blob);
  })
}


export const compressFile = (file, quality) => {
  return new Promise((resolve, reject) => {
    new Compressor(file, {
      quality: quality,
      maxWidth: 1400,
      maxHeight: 600,
      success(result) {
        resolve(result);
      },
      error(err) {
        reject(err.message);
      },
    });
  })
}
